/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

// core components
import Sair from "views/Login/Sair";
import Login from "views/Login/Login.js";
import LoginV2 from "views/Login/LoginV2";
import Admin from "layouts/Admin.js";
import CadastrarUsuario from "views/CadastrarUsuario/CadastrarUsuario.js";
import EsqueceuSenha from "views/EsqueceuSenha/EsqueceuSenha.js";
//import RTL from "layouts/RTL.js";

import "assets/css/material-dashboard-react.css?v=1.8.0";

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/app" component={Admin} />
      <Route path="/cadastrarUsuario/:parceiro?" component={CadastrarUsuario} />

      <Route path="/esqueceuSenha" component={EsqueceuSenha} />
      <Route path="/sair" component={Sair} />
      <Route path="/login" component={LoginV2} />
      <Route path="/" component={LoginV2} />
      {/* <Route path="/rtl" component={RTL} /> */}
      <Redirect from="/" to="/sair" />
    </Switch>
  </Router>,
  document.getElementById("root")
);
